module.exports = __webpack_public_path__ + "img/img5.6b6b1139.png";